var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisaOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.44531 1.71094H16.4453V14.2887H9.44531V1.71094Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88889 8C9.88889 5.44444 11.0889 3.17778 12.9333 1.71111C11.5778 0.644447 9.86666 0 8 0C3.57778 0 0 3.57778 0 8C0 12.4222 3.57778 16 8 16C9.86666 16 11.5778 15.3556 12.9333 14.2889C11.0889 12.8444 9.88889 10.5556 9.88889 8Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8904 8C25.8904 12.4222 22.3126 16 17.8904 16C16.0237 16 14.3126 15.3556 12.957 14.2889C14.8237 12.8222 16.0015 10.5556 16.0015 8C16.0015 5.44444 14.8015 3.17778 12.957 1.71111C14.3126 0.644447 16.0237 0 17.8904 0C22.3126 0 25.8904 3.6 25.8904 8Z",
    fill: "#F79E1B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaOrange);
export default __webpack_public_path__ + "static/media/visa-orange.ca0ba9d110394e5e288e5ca6d5077ba7.svg";
export { ForwardRef as ReactComponent };